module.exports = __webpack_public_path__ + "static/media/step5.58eeef8f.png";